import { useEffect, useState } from "react";
import cancel from "../../../assets/cancel.png";
import api from "../../../utils/api";
import "./User_Form.css";

const User_Form = ({ onClose, onSubmit, isEdit, data }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    role: "",
  });
  const [errors, setErrors] = useState({});
  const [roles, setRoles] = useState([]);

  const fetchRoles = async () => {
    const res = await api.get("/role/dropdown");
    setRoles(res.data.data);
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    if (isEdit && data) {
      setFormData({
        id: data.id || "",
        first_name: data.first_name || "",
        last_name: data.last_name || "",
        mobile_number: data.mobile_number || "",
        role: data.role_id || "",
      });
    }
  }, [isEdit, data]);
  //real time validation for each field
  const validateField = (name, value) => {
    const newErrors = { ...errors };
    switch (name) {
      case "first_name":
        newErrors.first_name = !value.trim() ? "First name is required" : "";
        break;
      case "last_name":
        newErrors.last_name = !value.trim() ? "Last name is required" : "";
        break;
      case "mobile_number":
        if (!value.trim()) newErrors.mobile_number = "Phone is required";
        else if (!/^\d{10}$/.test(value)) newErrors.mobile_number = "Phone must be 10 digits";
        else newErrors.mobile_number = "";
        break;
      case "role":
        newErrors.role = !value ? "Role is required" : "";
        break;
      default:
        break;
    }
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors(validateField(name, value));
  };
  // Validate the entire form when a field changes
  const validateForm = () => {
    const newErrors = {};
    if (!formData.first_name.trim()) newErrors.first_name = "First name is required";
    if (!formData.last_name.trim()) newErrors.last_name = "Last name is required";
    if (!formData.mobile_number.trim()) newErrors.mobile_number = "Phone is required";
    else if (!/^\d{10}$/.test(formData.mobile_number)) newErrors.mobile_number = "Phone must be 10 digits";
    if (!formData.role) newErrors.role = "Role is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    onSubmit(formData);
  };

  return (
    <div className="user__form_div_open">
      <div className="user__form">
        <div className="user__form_header">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <h1 style={{ padding: "0", margin: "0", fontSize: "24px" }}>{isEdit ? "Edit User" : "Add User"}</h1>
            <div className="user__form_img" onClick={onClose}>
              <img src={cancel} alt="Close" />
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <div className="user__form_input">
            <h5>First Name</h5>
            <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} className={`user__form_input_small ${errors.first_name ? "input-error" : ""}`} placeholder="Enter first name" style={{ width: "100%" }} />
            {errors.first_name && <span className="error">{errors.first_name}</span>}
          </div>
          <div className="user__form_input">
            <h5>Last Name</h5>
            <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} className={`user__form_input_small ${errors.last_name ? "input-error" : ""}`} placeholder="Enter last name" style={{ width: "100%" }} />
            {errors.last_name && <span className="error">{errors.last_name}</span>}
          </div>
          <div className="user__form_input">
            <h5>Phone</h5>
            <input type="text" name="mobile_number" value={formData.mobile_number} onChange={handleChange} className={`user__form_input_small ${errors.mobile_number ? "input-error" : ""}`} placeholder="Enter phone number" style={{ width: "100%" }} />
            {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
          </div>
          <div className="user__form_input">
            <h5>Role</h5>
            <select name="role" value={formData.role} onChange={handleChange} style={{ width: "100%" }} className={`user__form_input_small ${errors.role ? "input-error" : ""}`}>
              <option value="">Select Role</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name.toUpperCase()}
                </option>
              ))}
            </select>
            {errors.role && <span className="error">{errors.role}</span>}
          </div>
          <button type="submit" className="user__form_button">
            {isEdit ? "UPDATE" : "Add User"}
          </button>
        </form>
      </div>
    </div>
  );
};
export default User_Form;
